import { ReservationRequest, PaginatedResponse } from "../types/request";

export interface ReservationRequestParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export interface UpdateStatusParams {
  status: string;
  completedAt?: string;
}

export const createReservationRequestsApi = (
  callApi: (config: any) => Promise<any>
) => {
  return {
    /**
     * Fetch reservation requests with pagination and filtering
     */
    async fetchReservationRequests(
      params: ReservationRequestParams
    ): Promise<PaginatedResponse<ReservationRequest>> {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.search) queryParams.append("search", params.search);
      if (params.status) queryParams.append("status", params.status);
      if (params.sortBy) queryParams.append("sortBy", params.sortBy);
      if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);

      const response = await callApi({
        method: "GET",
        url: `/management/reservation-requests?${queryParams.toString()}`,
      });

      return response.data;
    },

    /**
     * Fetch a specific reservation request by ID
     */
    async fetchReservationRequestById(
      requestId: string
    ): Promise<ReservationRequest> {
      const response = await callApi({
        method: "GET",
        url: `/management/reservation-requests/${requestId}`,
      });

      return response.data;
    },

    /**
     * Update reservation request status
     */
    async updateReservationRequestStatus(
      requestId: string,
      params: UpdateStatusParams
    ): Promise<ReservationRequest> {
      const response = await callApi({
        method: "PUT",
        url: `/management/reservation-requests/${requestId}/status`,
        data: params,
      });

      return response.data;
    },
  };
};

export type ReservationRequestsApi = ReturnType<
  typeof createReservationRequestsApi
>;
